module.exports = __webpack_public_path__ + "img/b2.311bcfc1.jpg";